import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { OverlaySpinnerState } from './models/overlay-spinner.model';
import { OverlaySpinnerService } from './services/overlay-spinner.service';
import { ScrollService } from '@app/modules/registration/registration-card/services/scroll.service';

@Component({
  selector: 'overlay-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './overlay-spinner.component.html',
  styleUrls:['./overlay-spinner.component.scss']
})
export class OverlaySpinnerComponent implements OnInit, OnDestroy {
  state!: OverlaySpinnerState;
  private subscription = new Subscription();

  constructor(
    private spinnerService: OverlaySpinnerService,
    private scrollService:ScrollService
  ) {}

  ngOnInit(): void {
    this.subscription = this.spinnerService.getState()
      .subscribe(state => {
        this.state = state;
        if (state.show) {
          this.scrollService.disableScroll()
        } else {
          this.scrollService.enableScroll()
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.scrollService.enableScroll()
  }
}
